import { orange } from '@mui/material/colors';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  warningAlert: {
    border: `1px solid ${orange[200]}`,
    '& .MuiAlert-message': {
      fontWeight: 600,
      color: '#ed6c02',
    },
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    backgroundColor: theme.palette.background.paper,
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  sectionTitle: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    lineHeight: 1.35,
    '&::before': {
      content: '""',
      display: 'inline-block',
      height: 16,
      width: 3,
      backgroundColor: 'red',
      marginRight: 10,
      borderTopLeftRadius: 2,
      position: 'relative',
      top: 2,
    },
  },
  field: {
    '& .MuiDivider-root': {
      borderColor: 'rgba(0, 0, 0, 0.35)',
    },
  },
  fieldValue: {
    paddingTop: 2,
    paddingBottom: 2,
    minHeight: 20,
    fontWeight: 'bold',
    color: theme.palette.text.primary,
  },
  fileSectionHeader: {
    marginBottom: 6,
  },
  noFileUploaded: {
    lineHeight: 1.35,
    padding: 6,
    backgroundColor: theme.palette.grey[100],
    borderRadius: 4,
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
    border: `1px solid ${theme.palette.grey[300]}`,
  },
  fileItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: '4px 6px',
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  examSection: {
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  examSectionHeader: {
    backgroundColor: '#f5f5f5',
    paddingBottom: theme.spacing(2),
    padding: '10px 16px',
  },
  examSectionTitle: {
    marginLeft: 0,
    '&::before': {
      content: 'none',
    },
  },
  examContent: {
    padding: '10px 16px',
  },
  remainingQuota: {
    color: 'red',
    backgroundColor: '#ffdddd',
  },
  remainingQuotaDesc: {
    color: theme.palette.warning.main,
  },
}));
